import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';
import {HAS_LL} from '@constants/staticDropdowns';

export const LlFilter = ({
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        className='--customWidth --isLl'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        selection
        name='isLl'
        placeholder='LL?'
        options={HAS_LL}
        setValue={restoreFilterValues(filters, 'isLl')}
    />
);

LlFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
